export default "__VITE_ASSET__B4gjw1Tr__"